<template>
  <v-row
    style="border-top: 0.6px solid rgba(0, 0, 0, 0.12); cursor: pointer"
    class="pa-3 flex-nowrap chain-table-row"
    align-content-center
    @click="openNode()"
  >
    <div class="py-1 pl-3 d-flex align-center" style="min-width: 450px">
      <div
        class="mr-2"
        style="
          font-family: Inter;
          font-size: 12px;
          line-height: 12px;
          font-weight: 400;
          vertical-align: middle;
          color: #d0d0d0;
        "
      >
        {{ node.sort_order.toString().padStart(2, '0') }}
      </div>
      <v-icon class="mr-2" :color="nodeStatusColor" size="14"
        >mdi-circle</v-icon
      >
      <span class="node-name">{{ node.name }}</span>
      <v-chip
        outlined
        :color="nodeTypeColor"
        label
        class="ml-3"
        style="
          background-color: white !important;
          text-transform: capitalize;
          margin-top: -2px;
        "
      >
        {{ nodeType }}
      </v-chip>
    </div>
    <metric-value-chain-table-cell
      v-for="metric in activeMetrics(table)"
      :key="`${metric.module}/${metric.name}`"
      :width="metric.name == 'Address' ? '270px' : '180px'"
      :metric="metric"
      :node="node"
    />
    <div
      class="py-1 px-2"
      style="
        font-family: Inter;
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        vertical-align: middle;
        text-align: right;
        color: #d0d0d0;
        height: auto;
        width: 90px;
        position: inline-block;
        align-self: center;
      "
    >
      <span v-if="thisRawConnectionStatus">
        {{ nodeLatency.toFixed(0) }}ms
      </span>
      <span v-else>N/A</span>
    </div>
    <div
      class="py-1 px-3"
      style="
        font-family: Inter;
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        vertical-align: middle;
        text-align: right;
        color: #d0d0d0;
        height: auto;
        width: 90px;
        position: inline-block;
        align-self: center;
      "
    >
      <v-btn text icon color="black" @click="openNode()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-row>
</template>

<script>
import MetricValueChainTableCell from './MetricValueChainTableCell.vue';

import { mapGetters } from 'vuex';
import { nodeTypeDictReversed } from '../../services/nodeTypeService';

export default {
  components: {
    MetricValueChainTableCell,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    table: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters(['activeMetrics']),
    thisNodeStatus() {
      return this.nodeStatus(this.node);
    },
    thisRawConnectionStatus() {
      return this.getRawConnectionStatus(this.node);
    },
    nodeLatency() {
      let latencyAlerts = this.node.alerts.filter((alert) =>
        alert.metric.endsWith('/Latency')
      );

      let latencyValues = latencyAlerts.map(
        (alert) => this.$store.state.metrics.metric[alert.id]
      );

      let highestValue = Math.max(
        ...latencyValues.map(Number).filter((val) => !isNaN(val))
      );

      return highestValue;
    },
    nodeTypeColor() {
      let nodeType = this.node.type;
      if (nodeType == 0) return '#0d53ee';
      else if (nodeType == 1) return '#45e09e';
      else return '#479acc';
    },
    nodeType() {
      let nodeType = this.node ? this.node.type : null;
      if (nodeType in nodeTypeDictReversed) {
        return nodeTypeDictReversed[nodeType];
      }
      return 'Unknown';
    },
    nodeStatusColor() {
      switch (this.thisNodeStatus) {
        case 'active':
          return 'hsl(120, 67%, 39%)';
        case 'errors':
          return 'hsl(40, 87%, 49%)';
        case 'disconnected':
          return 'hsl(0, 87%, 59%)';
        default:
          return 'hsl(0, 0%, 59%)';
      }
    },
  },
  methods: {
    openNode() {
      this.$router.push(`/node/${this.node.chain_id}/${this.node.id}`);
    },
  },
};
</script>

<style scoped>
.chain-table-row .status-container {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  position: relative;
  vertical-align: middle;
}

.chain-table-row .status-indicator,
.chain-table-row .row-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1;
}

.chain-table-row .row-number {
  display: none;
}

.chain-table-row:hover .status-indicator {
  display: none;
}

.chain-table-row:hover .row-number {
  display: flex;
}

.node-name {
  font-family: Inter;
  font-size: 0.875rem;
  line-height: 1;
  font-weight: 600;
  vertical-align: middle;
}
</style>
